import { render, staticRenderFns } from "./FormControlContentContentTargetContentArea.vue?vue&type=template&id=4df1b31a"
import script from "./FormControlContentContentTargetContentArea.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlContentContentTargetContentArea.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports